export default __webpack_public_path__ + "static/media/cmr_white.514c1790.png";